<template>
  <div class="question-view" >
    <FixedFontSizeSelector>
    <div class="quest" :style="`${mode == 'viewAnswer' ? `--beforeShow: '';` : `--beforeShow: none;`}`">
      <!-- <el-button @click="determineCorrect" size="small"> 判断对错 </el-button>
      <el-button @click="correctAnswer" size="small"> 答案 </el-button> 
      -->
      
      <div class="title">
        <vue-mathjax @onRenderComplete="onRenderComplete(++mathjaxNum)" :formula="form.title" :safe="false"/>
      </div>
      <!-- <div class="ligature-list">
        <div class="single-test" v-for="(item, idx) in showData" :key="idx" >
          <div class="single" @mousedown="clickMouseDown($event, 'left')" @click="clickItemLeft($event, idx)">
            <div class="value" v-if="item.left.type == 'text'">
              <vue-mathjax :formula="item.left.textValue" :safe="false"/>
            </div>
            <div class="image" v-else :style="{backgroundImage: `url(${item.left.imgValue})`}"></div>
            <div class="line-drop"></div>
          </div>
          <div class="single" @mousedown="clickMouseDown($event, 'right')" @click="clickItemRight($event, idx)">
            <div class="line-drop"></div>
            <div class="value" v-if="item.right.type == 'text'">
              <vue-mathjax :formula="item.right.textValue" :safe="false"/>
            </div>
            <div class="image" v-else :style="{backgroundImage: `url(${item.right.imgValue})`}"></div>
          </div>
        </div>
      </div> -->
      <div class="ligature-list">
        <div class="left">
          <div class="single" v-for="(item, idx) in showData.left" :key="idx" v-show="!(item.textValue == '' && item.imgValue == '')"
            v-drag_ligature="{self, type: 'left', isShow: !(item.textValue == '' && item.imgValue == '')}" 
            @click="clickItemLeft($event, idx)">
            <div class="value" v-if="item.type == 'text'">
              <vue-mathjax @onRenderComplete="onRenderComplete(++mathjaxNum)" :formula="item.textValue" class="span" :safe="false"/>
            </div>
            <div class="image" v-else :style="{backgroundImage: `url(${item.imgValue})`}"></div>
            <div class="line-drop"></div>
          </div>
        </div>
        <!-- <div class="left">
          <div class="single" v-for="(item, idx) in showData.left" :key="idx" v-show="!(item.textValue == '' && item.imgValue == '')"
          @mousedown="clickMouseDown($event, 'left')" @click="clickItemLeft($event, idx)">
            <div class="value" v-if="item.type == 'text'">
              <vue-mathjax :formula="item.textValue" :safe="false"/>
            </div>
            <div class="image" v-else :style="{backgroundImage: `url(${item.imgValue})`}"></div>
            <div class="line-drop"></div>
          </div>
        </div> -->
        <div class="right">
          <div class="single" v-for="(item, idx) in showData.right" :key="idx" v-show="!(item.textValue == '' && item.imgValue == '')"
          v-drag_ligature="{self, type: 'right', isShow: !(item.textValue == '' && item.imgValue == '')}"
          @click="clickItemRight($event, idx)">
            <div class="line-drop"></div>
            <div class="value" v-if="item.type == 'text'">
              <vue-mathjax @onRenderComplete="onRenderComplete(++mathjaxNum)" :formula="item.textValue" class="span" :safe="false"/>
            </div>
            <div class="image" v-else :style="{backgroundImage: `url(${item.imgValue})`}"></div>
          </div>
        </div>

      </div>

      <div class="test-self">
      </div>
    </div>
    </FixedFontSizeSelector>
  </div>
</template>

<script>
import { clickMouseDown } from './pc_event'
import { clickTouchDown } from './mobile_event'
import FixedFontSizeSelector from '@/views/student/components/FontSizeSelector'
export default {
  components: {
    FixedFontSizeSelector
  },
  props: ['form', 'mode'],
  data() {
    let letter = new Array(26).fill().map((its, idx) => its = String.fromCharCode(65 + idx))

    return {
      mathjaxNum: 0,
      letter,
      topic: '',
      ligatureList: [],
      showData: {left: [], right: []},

      /**
       * 记录坐标数据 
       *    {direction: 'left', key: '0', left: 0, top: 0} -> 「左栏」「索引为0」的坐标为 (「0, 0」)
       *    限制：每栏只能添加一组数据（eg: 左栏存在数据只允许被替换）
       */
      recordPosition: [],
      // 存储已连线数据
      storageLigature: new Map(),
      answer_results: {
        id: null,
        student_choices: []
      },
      recordQuestion: {},
      // 记录答题次数
      limit: 0,
      self: this
    }
  },
  watch: {
    'form.id': {
      handler() {
        this.initData()
      },
      deep: true
    }
  },
  methods: {
    onRenderComplete(i) {
      let num = 1 + 
        this.showData.left.filter(its => its.type == 'text' && its).length +
        this.showData.right.filter(its => its.type == 'text' && its).length

      if(i == num) {
        this.$parent.loading = false
      }
    },
    // 重置
    resetting(next = false) {
      // 数据清空
      this.recordPosition = []
      this.storageLigature = new Map()
      if(next == false) this.$emit('permissions', next)
      
      // 样式清空
      let lines = document.querySelectorAll('.line-segment'),
      lineParent = lines .length > 0 && lines[0].parentNode
      for(let i = 0; i < lines.length; i++) {
        lineParent.removeChild(lines[i])
      }
      
      this.recordQuestion = {}
      this.answer_results = {
        id: null,
        student_choices: []
      }
      this.limit = 0
      if(next == false) this.repariRecordQuestion()
    },
    repariRecordQuestion() {
      this.$emit('repariRecordQuestion', this.recordQuestion, this.limit)
    },
    showTrueFalse() {
      let { form, recordQuestion } = this,
      answers = form.answers.map((its, idx) => {
        let ids = its.value.split(',')
        return ids.map(i => `left-${idx}-${i}`)
      }).flat()

      if(Object.keys(recordQuestion).length == 0) {
        return ;
      }
      
      console.log(recordQuestion)

      this.limit = 1

      // 回显答案
      for(let i in recordQuestion) {
        let its = recordQuestion[i].split(',')
        for(let j = 0; j < its.length; j++) {
          // 获取对应的 line-drop 节点
          let leftDom = document.querySelector('.ligature-list .left').querySelectorAll('.single')[i].querySelector('.line-drop'),
          rightDom = document.querySelector('.ligature-list .right').querySelectorAll('.single')[its[j]].querySelector('.line-drop')

          // 获取 line-drop 坐标
          let pos1 = {left: leftDom.offsetLeft, top: leftDom.offsetTop}
          pos1.left += leftDom.offsetWidth / 2
          pos1.top += leftDom.offsetHeight / 2
          pos1.direction = 'left'
          pos1.key = i

          // 获取 line-drop 坐标
          let pos2 = {left: rightDom.offsetLeft, top: rightDom.offsetTop}
          pos2.left += rightDom.offsetWidth / 2
          pos2.top += rightDom.offsetHeight / 2
          pos2.direction = 'right'
          pos2.key = its[j]

          // 记录连线数据
          this.recordPosition = [
            pos1,
            pos2
          ]
          this.handleLigatureData()

          // 连线
          // 判断线段是否存在
          let lineNode = document.querySelector(`.${pos1.direction}-${pos1.key}-${pos2.key}`)
          if(!lineNode) this.ligature(pos1, pos2)
        }
      }

      if(this.mode == 'question') {
        return ;
      }
      let blocks = document.querySelectorAll('.line-segment')
      // 回显对错
      for(let i = 0; i < blocks.length; i++) {
        blocks[i].classList.add('line-segment-error')
      }
      console.log(answers)

      for(let i = 0; i < answers.length; i++) {
        // console.log(answers[i])
        let dom = document.querySelectorAll(`.${answers[i]}`)
        // console.log(dom)
        for(let i = 0; i < dom.length; i++)
          dom[i] && dom[i].classList.add('line-segment-success')
      }
      console.log(form)
    },
    // 正确答案
    correctAnswer() {
      let { showData } = this, answer = []

      // 将打乱的数据放在同一维数组里
      for(let i = 0; i < showData.length; i++) {
        let {left: {tips}} = showData[i]
        
        for(let j = 0; j < showData.length; j++) {
          let {right} = showData[j],
          rightTips = right.tips
          
          // tips == rightTips 
          if(rightTips.includes(tips)) {
            answer.push([i, j])
          }
        }
      }

      for(let i = 0; i < answer.length; i++) {
        let [left, right] = answer[i],
        // 获取对应的 line-drop 节点
        leftDom = document.querySelectorAll('.ligature-list .single-test')[left].querySelectorAll('.single')[0].querySelector('.line-drop'),
        rightDom = document.querySelectorAll('.ligature-list .single-test')[right].querySelectorAll('.single')[1].querySelector('.line-drop')

        // 获取 line-drop 坐标
        let pos1 = {left: leftDom.offsetLeft, top: leftDom.offsetTop}
        pos1.left += leftDom.offsetWidth / 2
        pos1.top += leftDom.offsetHeight / 2
        

        // 获取 line-drop 坐标
        let pos2 = {left: rightDom.offsetLeft, top: rightDom.offsetTop}
        pos2.left += rightDom.offsetWidth / 2
        pos2.top += rightDom.offsetHeight / 2

        console.log(pos1, pos2)
        // 连线
        this.ligature(pos1, pos2)
      }
    },

    // 判断对错
    determineCorrect() {
      let keys = [...this.storageLigature.values()]
      
      let res = keys.map((its) => {
        let [val1, val2] = its
        return val2.tips.includes(val1.tips)
      })

      console.log(res)
    },
    // 学生答题结果
    studentQuestionResult() {
      let keys = [...this.storageLigature.keys()],
      resultMap = new Array(6).fill(null)
      console.log(keys)
      
      for(let i = 0; i < keys.length; i++) {
        let [pos, idx1, idx2] = keys[i].split('-')
        if(pos == 'right') {
          [idx1, idx2] = [idx2, idx1]
        }
        
        if(resultMap[idx1]) resultMap[idx1]['value'].push(idx2)
        else {
          resultMap[idx1] = {
            value: [idx2]
          }
        }
      }
      
      this.recordQuestion = {}
      resultMap = resultMap.map((its, idx) => {
        if(its) {
          this.recordQuestion[idx] = its.value.sort().join(',')
          return {value: its.value.sort().join(',')}
        }
        return null
      })
      this.answer_results.student_choices = resultMap
    },

    clickMouseDown,

    clickTouchDown,

    clickItemLeft(e, idx) {
      // 存在 e.target 为子节点 获取父节点后再作处理
      let eareBox = e.target.classList.contains('single') ? e.target : e.target.parentNode,
      lineDrop = eareBox.querySelector('.line-drop')
      
      // 获取坐标 (.line-drop 圆心位置) 以.ligature-list左上为原点
      let drop = {left: lineDrop.offsetLeft, top: lineDrop.offsetTop}
      drop.left += lineDrop.offsetWidth / 2
      drop.top += lineDrop.offsetHeight / 2
      
      // 记录数据
      let data = {direction: 'left', key: idx, ...drop},
      record = this.recordPosition,
      isExist = record.some(its => its.direction == 'left')

      // 判断是否已经存在左侧数据 存在就替换 不存在则追加
      if(isExist) {
        let key = record.map(its => its.direction == 'left').indexOf(true)
        record[key] = data
      } else this.recordPosition.push(data); 
      
      // 左右栏同时存在
      if(record.length == 2) this.handleLigatureData()
    },

    clickItemRight(e, idx) {
      // 存在 e.target 为子节点 获取父节点后再作处理
      let eareBox = e.target.classList.contains('single') ? e.target : e.target.parentNode,
      lineDrop = eareBox.querySelector('.line-drop')

      // 获取坐标 (.line-drop 圆心位置) 以.ligature-list左上为原点
      let drop = {left: lineDrop.offsetLeft, top: lineDrop.offsetTop}
      drop.left += lineDrop.offsetWidth / 2
      drop.top += lineDrop.offsetHeight / 2

      // 记录数据
      let data = {direction: 'right', key: idx, ...drop},
      record = this.recordPosition,
      isExist = record.some(its => its.direction == 'right')

      // 判断是否已经存在右侧数据 存在就替换 不存在则追加
      if(isExist) {
        let key = record.map(its => its.direction == 'right').indexOf(true)
        record[key] = data
      } else this.recordPosition.push(data); 
      
      // 左右栏同时存在
      if(record.length == 2) this.handleLigatureData()
    },

    // 处理连线数据
    handleLigatureData() {
      let [pos1, pos2] = this.recordPosition,
      key = `${pos1.direction}-${pos1.key}-${pos2.key}`,
      reversalKey = `${pos2.direction}-${pos2.key}-${pos1.key}`
      
      // 过滤线段
      if(this.storageLigature.has(key) || this.storageLigature.has(reversalKey)) return 

      // 连线
      this.ligature(pos1, pos2)

      // 存储连线数据
      let [direction, key1, key2] = key.split('-')

      this.storageLigature.set(key, [this.ligatureList[key1][direction], 
            this.ligatureList[key2][direction == 'left' ? 'right' : 'left']])
      console.log(this.storageLigature)
      console.log(this.recordPosition)
      this.$emit('permissions', true)
      this.limit = 1
      this.studentQuestionResult()
      // 清空当前连线数据
      this.recordPosition = []
    },

    // 连线
    ligature(pos1, pos2, area = '.ligature-list') {
      let centerPos;

      // 获取中心坐标
      centerPos = {
        left: Math.round((pos1.left + pos2.left) / 2),
        top: Math.round((pos1.top + pos2.top) / 2),
      };

      // 获取 pos1, pos2之间的距离
      let pos1_2Distance;
      if(pos1.top == pos2.top) {
        pos1_2Distance = Math.abs(pos1.left - pos2.left)
      } else {
        let leftDiff = Math.abs(pos1.left - pos2.left),
        topDiff = Math.abs(pos1.top - pos2.top)

        pos1_2Distance = Math.round(Math.sqrt(leftDiff ** 2 + topDiff ** 2))
      }

      // 获取 pos1, pos2连线后与水平线的夹角
      let posDiff = {top: pos1.top - pos2.top, left: pos1.left - pos2.left},
      rotate = Math.round(Math.atan2(posDiff.top, posDiff.left) * (180 / Math.PI))
      
      // 创建线段
      let line = document.createElement('div')
      line.setAttribute('class', `line-segment ${pos1.direction}-${pos1.key}-${pos2.key}`) //以两栏索引为名
      line.style = `
        width: ${pos1_2Distance}px;
        top: ${centerPos.top}px;
        left: ${centerPos.left - pos1_2Distance / 2}px;
        transform: rotate(${rotate}deg);
      `
      document.querySelector(area).append(line)

      // 给线段添加点击事件
      if(area == '.ligature-list') {
        line.onclick = () => {
          let key = `${pos1.direction}-${pos1.key}-${pos2.key}`

          // 删除连线数据
          this.storageLigature.delete(key)

          // 删除dom
          document.querySelector(area).removeChild(line)

          // 更新学生答案
          this.studentQuestionResult()
        }
      }
    },

    // 清除记录，清除线段
    remove() {
      let keys = [...this.storageLigature.keys()],
      parent = document.querySelector('.ligature-list'),
      childs = parent.querySelectorAll('.line-segment')

      for(let i = childs.length - 1; i >= 0 ; i--) {
        parent.removeChild(childs[i])
      }
      keys.filter(item => {
        this.storageLigature.delete(item)
      })

      this.studentQuestionResult()
      if(this.storageLigature.keys().length == 0) {
        this.$emit('permissions', false)
        this.limit = 0
      }
    },
    initData() {
      this.answer_results = {
        id: null,
        student_choices: []
      }
      this.recordQuestion = {}
      this.recordPosition = []
      this.storageLigature = new Map()
      this.ligatureList = []
      this.showData = { left: [], right: []  }
      
      let content = JSON.parse(this.form.content)
      console.log(content)
      this.ligatureList = content.ligatureList
      content.ligatureList.filter(its => {
        if(its.left.textValue != '' || its.left.imgValue != ''){
          this.showData.left.push(its.left)
        }
        if(its.right.textValue != '' || its.right.imgValue != ''){
          this.showData.right.push(its.right)
        }
      })

      this.resetting(true)
      // if(this.mode == 'viewAnswer') 
      setTimeout(() => this.showTrueFalse(), 500)
    }
  },
  created() {
    this.initData()
  }
}
</script>

<style scoped lang="scss">
@import url('../../static/pubile.scss');

.question-view {
  width: 700px;
  min-height: 400px;
  padding: 0px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 10px;
  .quest {
    width: 100%;
    height: 100%;

    .title {
      font-size: 15px;
      color: #333;
    }

    .ligature-list {
      width: 330px;
      min-height: 330px;
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      align-content: flex-start;
      flex-wrap: wrap;
      position: relative;
      user-select: none;

    

      .left, .right {
        width: 120px;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;

        .single {
          width: 100%;
          height: fit-content;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
          cursor: pointer;

          .value {
            width: 100px;
            min-height: 45px;
            border-radius: 10px;
            background-color: #fee8d2;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            padding: 5px 10px;
            position: relative;
            word-wrap: break-word;
            text-align: center;  /* 纯文本水平居中 */
            .span {
              width: 100%;
            }

            &:before {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              z-index: 1;
              width: 100%;
              height: 100%;
            }
          }

          .image {
            width: 100px;
            height: 100px;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;

            & > img {
              width: 100%;
              height: 100%;
            }
          }

          .line-drop {
            width: 10px;
            height: 10px;
            background-color: #d17223;
            border-radius: 50%;
            cursor: pointer;
            position: relative;

            &:before {
              content: '';
              position: absolute;
              top: -2px;
              left: -2px;
              width: 100%;
              height: 100%;
              border-radius: 50%;
              box-sizing: initial;
              border: 2px solid transparent;
              transition: all .5s;
            }
             
          }

          &:hover {
            .line-drop:before {
              border-color: skyblue;
            }
          }
        }

        .select {
          .line-drop:before {
            border-color: skyblue;
          }
        }

        .single:nth-last-of-type(1) {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.line-segment {
  position: absolute;
  height: 2px;
  background-color: #333;
  transform-origin: center center;
  // z-index: 999999;

  &:hover {
    background-color: #1a94fa;
    cursor: pointer;
  }
}

.line-segment-error {
  background-color: #d60215;
}

.line-segment-success {
  background-color: #007416;
}

</style>